import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support
import React from 'react';
import { createRoot } from 'react-dom/client';
import ApplicationStateful from "./pages/ApplicationStateful";
import {BrowserRouter} from "react-router-dom";
import './i18n';

createRoot(document.getElementById("app")).render(

    <BrowserRouter>

        <ApplicationStateful />

    </BrowserRouter>

);
